export default __webpack_public_path__ + "static/media/customer.7e4487d9.svg";